import Base from "./Base";
import store from "../storeWire";
import { setAll } from "../store/slice/model/ProductInventory";
import Auth from "@system/config/auth";

class ProductInventory extends Base {
    setAll(data, justProcess = false) {
        if (justProcess) {
            data = this.matchAll(data.data);
            data = this.processAll(data);
            return data;
        }
        this.data = data;
        this.matchAll();
        this.processAll();
        store.dispatch(setAll({
            data: this.data
        }));
    }

    matchAll(data = false) {
        let dataHere = data;
        if (!dataHere) {
            dataHere = this.data;
        }

        if (dataHere.length) {
            this.data = dataHere.map((v) => {
                let tempV = { ...v }
                tempV.ERPPartNumber = v.matnr;
                tempV.quantity = v.qas;
                return tempV;
            })
        }
        return this.data;
    }

    setParamsForServerCall(params_single) {
        if (params_single.ERPPartNumber) {
            params_single.matnr = params_single.ERPPartNumber;
            delete params_single.ERPPartNumber
        }
        if (params_single.ERPManufacturerCode) {
            params_single.mfr = params_single.ERPManufacturerCode;
            delete params_single.ERPManufacturerCode
        }

        //Adding Default Value
        if (!params_single.sboat) {
            params_single.sboat = Auth.getAuthSBoat();
        }
        if (!params_single.matnr) {
            params_single.matnr = '';
        }
        if (!params_single.mfr) {
            params_single.mfr = '';
        }
        if (params_single.reQ_DATE === undefined) {
            params_single.reQ_DATE = '';
        }

        return params_single;
    }

    processAll(data = false) {
        let dataHere = data;
        if (!dataHere) {
            dataHere = this.data;
        }
        if (dataHere.length) {
            let here = {};
            dataHere.map((v) => {
                let ERPPartNumber = v.ERPPartNumber;
                here[ERPPartNumber] = v;
            });
            this.data = here;
        }
        return this.data;
    }
}

export default ProductInventory;